import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { CommonProgrammingContext } from '../services/shared-programming.service';
import { SharedProgrammingService } from './../services/shared-programming.service';

@Component({
  selector: 'prg-programming-header',
  templateUrl: './programming-header.component.html'
})
export class ProgrammingHeaderComponent implements OnInit {

  constructor(
    protected router: Router,
    private store: Store<{ sharedProgramming: CommonProgrammingContext }>
  ) {
  }

  ngOnInit() {
    console.log('header: init');
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/programming-header/programming-header.component.ts